import type {
  PartnerDocumentBlueprint,
  PartnerDocumentBlueprintCreate,
  PartnerDocumentBlueprintUpdate,
} from '@shipium-corp/shipium-ts-types';
import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';

export const documentBlueprints = {
  search: {
    queryKey: 'partner-management-service/document-blueprints',
    configurationType: 'default' as const,
    fn: async () => {
      const { data } = await GatewayAxiosClient.get<PartnerDocumentBlueprint[]>(
        `/partner-management-proxy/api/v1/partners/documentBlueprints`,
      );

      return data;
    },
  },
  get: {
    queryKey: 'partner-management-service/document-blueprints/id',
    configurationType: 'no-cache' as const,
    fn: async (documentBlueprintId: string) => {
      const { data } = await GatewayAxiosClient.get<PartnerDocumentBlueprint>(
        `/partner-management-proxy/api/v1/partners/documentBlueprints/${documentBlueprintId}`,
      );

      return data;
    },
  },
  create: async (payload: PartnerDocumentBlueprintCreate) => {
    const { data } = await GatewayAxiosClient.post<PartnerDocumentBlueprint>(
      `/partner-management-proxy/api/v1/partners/documentBlueprints`,
      payload,
    );

    return {
      data,
      invalidateQueryKeys: [['partner-management-service/document-blueprints']],
    };
  },
  update: async ({
    documentBlueprintId,
    payload,
  }: {
    documentBlueprintId: string;
    payload: PartnerDocumentBlueprintUpdate;
  }) => {
    const { data } = await GatewayAxiosClient.put<PartnerDocumentBlueprint>(
      `/partner-management-proxy/api/v1/partners/documentBlueprints/${documentBlueprintId}`,
      payload,
    );

    const id = data.documentBlueprintId;
    return {
      data,
      invalidateQueryKeys: [
        ['partner-management-service/document-blueprints'],
        ...(id ? [['partner-management-service/document-blueprints/id', id]] : []),
      ],
    };
  },
  delete: async (documentBlueprintId: string) => {
    await GatewayAxiosClient.delete(
      `/partner-management-proxy/api/v1/partners/documentBlueprints/${documentBlueprintId}`,
    );

    return {
      invalidateQueryKeys: [['partner-management-service/document-blueprints']],
    };
  },
};
